import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.952 20.656c-.846-.826-2.01-1.79-3.137-2.994s-2.256-1.893-1.692-3.855c.67-2.375 4.336-2.72 5.464-.344C15.899 16.224 13.226 16.5 13 15c-.212-1.406 2.997-4.532 5.606-2.26 2.679 2.34-1.622 5.507-2.962 6.987s-1.34 1.273-1.692.929Z"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.635 21C5.317 18.866 5 16.457 5 13.325s6.17-4.061 6.17-4.061C9.83 8.85 8.877 7.646 8.877 6.2 8.878 4.41 10.358 3 12.156 3s3.279 1.446 3.279 3.2c0 1.274-.74 2.341-1.833 2.892 0 0 1.269-.31 3.384.826"
    />
  </svg>
);
export const ClientsIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
